module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.members.title')))]), _vm._v(" "), _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.navigateTab
    },
    model: {
      value: (_vm.current_tab),
      callback: function($$v) {
        _vm.current_tab = $$v
      },
      expression: "current_tab"
    }
  }, [_c('el-tab-pane', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "label": _vm.$t('static.members.index.tab.members'),
      "name": "members"
    }
  }, [(_vm.membersLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', [_c('el-button', {
    staticClass: "small",
    on: {
      "click": _vm.addMember
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('static.members.index.addMember')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "stripe": "",
      "data": _vm.organization_members
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "color",
      "width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "member_color",
          style: ('background-color:' + scope.row.color)
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user.first_name",
      "label": _vm.$t('static.members.index.table.members.firstName'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user.last_name",
      "label": _vm.$t('static.members.index.table.members.lastName'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user.email",
      "label": _vm.$t('static.members.index.table.members.email'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "color",
      "label": _vm.$t('static.members.index.table.members.title'),
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t        \t" + _vm._s(scope.row.title) + "\n\t\t\t\t\t        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_accepted",
      "label": _vm.$t('static.members.index.table.members.status'),
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": (_vm.acceptStatus(scope.row) == 'ACTIVE') ? 'success' : 'info'
          }
        }, [_vm._v("\n\t\t\t\t\t\t  \t\t\t" + _vm._s(_vm.acceptStatus(scope.row)) + "\n\t\t\t\t\t\t  \t\t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          staticClass: "el-button small el-button--default",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "to": '/members/' + scope.row.id.toString()
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        }), _vm._v("  " + _vm._s(_vm.$t('static.members.index.table.members.view')) + "\n\t\t\t\t\t        ")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "label": _vm.$t('static.members.index.tab.calendarSchedule'),
      "name": "calendar_schedule"
    }
  }, [(_vm.calendarLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', [_c('el-select', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    model: {
      value: (_vm.calendar_data_type),
      callback: function($$v) {
        _vm.calendar_data_type = $$v
      },
      expression: "calendar_data_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('static.members.index.options.businessHours'),
      "value": "businesshours"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('static.members.index.options.booking'),
      "value": "bookings"
    }
  })], 1), _vm._v(" "), _c('FullCalendar', {
    ref: "fullCalendar",
    class: _vm.calendar_data_type == 'bookings' ? 'fc-event-clickable' : '',
    attrs: {
      "customButtons": _vm.customButtons,
      "header": _vm.header,
      "minTime": _vm.min_time,
      "slotDuration": _vm.timeslot_gap,
      "selectable": _vm.calendar_data_type == 'bookings',
      "selectAllow": _vm.selectAllow,
      "defaultView": _vm.default_view,
      "events": _vm.events,
      "allDaySlot": false,
      "height": "auto",
      "slotEventOverlap": false,
      "eventRender": _vm.showToolTip,
      "plugins": _vm.calendarPlugins,
      "buttonText": {
        today: _vm.$t('static.members.index.calendar.today')
      },
      "firstDay": 1,
      "locale": "nb",
      "datesRender": _vm.updateBookingEvents
    },
    on: {
      "dateClick": _vm.handleSlotClick,
      "eventClick": _vm.handleEventClick
    }
  })], 1)])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f00b5ec","hasScoped":true}!./src/app/pages/withNavigation/members/index/index.html
// module id = 3080
// module chunks = 1